import React, { useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { useNavigate } from 'react-router-dom';

function Login() {
  const { oktaAuth, authState } = useOktaAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!authState) {
      return;
    }

    if (authState.isAuthenticated) {
      navigate('/');
    } else {
      oktaAuth.signInWithRedirect();
    }
  }, [authState, oktaAuth, navigate]);

  return (
    <div style={{ textAlign: 'center', marginTop: '100px' }}>
      <h2>Redirecting to Okta login...</h2>
    </div>
  );
}

export default Login;
